module.exports = __webpack_public_path__ + "img/3.e237da97.jpg";